import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface ErrorModalState {
  showErrorModal: boolean;
  errorMessage: string;
  errorSubMessage: string;
}

export const errorModalInitialState: ErrorModalState = {
  showErrorModal: false,
  errorMessage: '',
  errorSubMessage: '',
};

const ErrorModalSlice = createSlice({
  name: 'errorModal',
  initialState: errorModalInitialState,
  reducers: {
    open(
      state,
      action: PayloadAction<{ message: string; subMessage?: string }>
    ) {
      state.showErrorModal = true;
      state.errorMessage = action.payload.message;
      state.errorSubMessage = action.payload.subMessage || '';
    },
    close(state) {
      state.showErrorModal = false;
      state.errorMessage = '';
      state.errorSubMessage = '';
    },
    // Fire-and-forget action that saga will translate to close->open
    trigger(
      state,
      _action: PayloadAction<{ message: string; subMessage?: string }>
    ) {
      // no state changes here; handled in saga
    },
  },
});

export const { open, close, trigger } = ErrorModalSlice.actions;
export default ErrorModalSlice.reducer;
